<template>
  <AuthLayout>
    <Forgot />
  </AuthLayout>
</template>

<script>
  import AuthLayout from '../layouts/Auth';
  import Forgot from '../containers/auth/Forgot';

  export default {
    name: 'ForgotPage',
    components: { AuthLayout, Forgot },
  };
</script>
